import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Download, RefreshCcw, Loader2 } from "lucide-react";
import ReportView from "../components/ReportView";
import { Logo } from "../components/Logo";
import { WhatsAppFab } from "../components/WhatsAppFab";
import { api, errMsg, downloadPdf } from "../lib/api";

const sampleCustomer = (inspection) => ({
  ...inspection,
  customer: {
    ...inspection.customer,
    name: "Sample Customer",
    phone: "—",
    email: "—",
  },
  property: { ...inspection.property, project: "Sample Residence", flat: "—" },
  inspector_name: "PossessionCheck Inspection Team",
});

export default function PublicReport() {
  const { iid } = useParams();
  const [sp] = useSearchParams();
  const t = sp.get("t") || "";
  const isSample = sp.get("sample") === "1";
  const [ins, setIns] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get(`/public/report/${iid}`, { params: { t } })
      .then(({ data }) => setIns(isSample ? sampleCustomer(data) : data))
      .catch((e) => setErr(errMsg(e)));
  }, [iid, isSample, t]);

  const pdf = async () => {
    setBusy(true);
    try {
      await downloadPdf(iid, t);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const request = async () => {
    try {
      await api.post(
        `/public/report/${iid}/reinspection-request`,
        { note: "Requested from report link" },
        { params: { t } },
      );
      toast.success("Re-inspection requested. Our team will contact you.");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const btn =
    "tap flex h-11 items-center gap-2 rounded-md px-4 text-sm font-semibold";
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/85 backdrop-blur-md">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
          <Link to="/">
            <Logo />
          </Link>
          <span className="font-mono text-[10px] text-slate-500">
            SECURE REPORT LINK
          </span>
        </div>
      </header>
      <main className="px-4 py-6">
        {err && (
          <div
            className="mx-auto max-w-md rounded-lg border border-slate-200 bg-white p-8 text-center"
            data-testid="public-report-error"
          >
            <div className="font-display text-xl font-bold">
              Report unavailable
            </div>
            <p className="mt-2 text-sm text-slate-500">{err}</p>
          </div>
        )}
        {!ins && !err && (
          <div className="grid place-items-center py-24">
            <Loader2 className="h-6 w-6 animate-spin text-teal-600" />
          </div>
        )}
        {ins && (
          <ReportView
            ins={ins}
            actions={
              !isSample && (
                <>
                  <button
                    onClick={pdf}
                    className={`${btn} bg-teal-500 text-slate-950 hover:bg-teal-400`}
                    data-testid="public-download-pdf-button"
                  >
                    {busy ? (
                      <Loader2 className="h-4 w-4 animate-spin" />
                    ) : (
                      <Download className="h-4 w-4" />
                    )}{" "}
                    Download PDF
                  </button>
                  <button
                    onClick={request}
                    className={`${btn} border border-slate-700 text-white hover:bg-slate-800`}
                    data-testid="public-request-reinspection-button"
                  >
                    <RefreshCcw className="h-4 w-4" /> Request re-inspection
                  </button>
                </>
              )
            }
          />
        )}
      </main>
      <WhatsAppFab />
    </div>
  );
}
